import React, { useEffect, useState } from "react";
import { Card, ListGroup, Modal, Button } from "react-bootstrap";
import { notificationService } from "../services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

function Notification({ onUnreadChange = () => {} }) {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const [selectedNotification, setSelectedNotification] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getNotificationList();
  }, []);

  // Fetch Notification List
  const getNotificationList = async () => {
    try {
      const payload = {
        pageNumber: 1,
        pageSize: 10,
      };
      const res = await notificationService.getNotification(payload);
      if (res && res.data) {
        const list = res.data.notificationList;
        setNotifications(list);
        // setNotifications(res.data.notificationList);

        /* ---------- NEW ---------- */
        const unread = list.filter((n) => !n.isRead).length;
        onUnreadChange(unread); // lift the count up
      }
    } catch (error) {
      console.log("Error fetching notifications list");
    }
  };

  // Fetch Notification Details
  const getNotificationDetails = async (id) => {
    try {
      const res = await notificationService.getNotificationDetails(id);
      if (res && res.data) {
        setSelectedNotification(res.data);

        setShowModal(true);
        await ReadNotification(id);
        await getNotificationList(id);
      }
    } catch (error) {
      console.log("Error fetching notification details");
    }
  };

  // READ Notification
  const ReadNotification = async (id) => {
    try {
      const res = await notificationService.getReadNotification(id);
      if (res && res.data) {
        console.log("first", res.data);
      }
    } catch (error) {
      console.log("Error fetching notifications list");
    }
  };

  // Notification Notification
  const DeleteNotification = async (id) => {
    try {
      const res = await notificationService.DeleteNotification(id);
      if (res && res.data) {
        toast.success("Notification deleted successfully");
        getNotificationList();
      }
    } catch (error) {
      toast.error("Failed to delete notification");
      console.log("Error fetching notifications list");
    }
  };

  // time format
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return {
      date: `${day}/${month}/${year}`, // dd/mm/yyyy
      time: `${hours}:${minutes}`, // HH:mm
    };
  };

  const renderButton = () => {
    if (!selectedNotification?.category) return null;

    switch (selectedNotification.category.toLowerCase()) {
      case "reward":
        return (
          <Button
            className="popupButton"
            onClick={() => {
              setShowModal(false);
              // navigate("/rewardsPage");
              navigate("/rewardsPage", {
                state: {
                  rewardId: selectedNotification?.eventId, // ensure this is passed from notification
                },
              });
            }}
          >
            Reward
          </Button>
        );
      case "booking":
        return (
          <Button
            className="popupButton"
            onClick={() => {
              window.location.href = "https://www.danddlondon.com";
            }}
          >
            Go to Booking
          </Button>
        );
      case "notification":
      default:
        return (
          <Button className="popupButton" onClick={() => setShowModal(false)}>
            CLOSE
          </Button>
        );
    }
  };

  return (
    <div className="tab-content-container all-box88  bglc">
      <Card className="notification-all-box">
        <h5>Notifications</h5>
        {notifications?.length > 0 ? (
          <ListGroup variant="flush">
            {notifications.map((notification, index) => (
              <ListGroup.Item
                key={index}
                className="d-flex justify-content-between align-items-center customlist"
                style={{
                  backgroundColor: notification.isRead ? "white" : "#FD948D",
                }}
                onClick={() => getNotificationDetails({ id: notification.id })}
              >
                <div className="noti-design1">
                  <div className="noti-design2 mobile-noti">
                    <span className="mobile-noti-date">
                      {formatDateTime(notification.createdDate).date}
                    </span>
                    <span className="mx-3 mobile-noti-time">
                      {formatDateTime(notification.createdDate).time}
                    </span>
                    <span
                      className="text-truncate mobile-noti-title"
                      style={{
                        maxWidth: "300px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {notification.subject.replace(/<\/?[^>]+(>|$)/g, "")}
                    </span>
                  </div>

                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      DeleteNotification(notification.id);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src="/images/delete.png"
                      alt="Delete"
                      className="custom-icon"
                    />
                  </span>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <p className="text-center text-muted">
            No new notifications, check back later.
          </p>
        )}
      </Card>

      {/* Notification Details Modal */}
      <Modal
        className="modelpopup222 "
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <div className="popupall">
          <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>

          <Modal.Body className="popupbody">
            {selectedNotification && (
              <>
                {selectedNotification.image && (
                  <img
                    src={selectedNotification.image}
                    alt="Notification"
                    className="img-fluid rounded mb-3"
                  />
                )}
                <h5 className="fw-bold">{selectedNotification.subject}</h5>
                <ps className="text-muted firt">
                  Date:{" "}
                  <strong>
                    {formatDateTime(selectedNotification.createdDate).date}
                  </strong>
                  <br />
                  <p className="third">
                    Time:{" "}
                    <strong>
                      {formatDateTime(selectedNotification.createdDate).time}
                    </strong>
                  </p>
                </ps>
                {/* <p className="text-muted second">
                  {selectedNotification.message.replace(/<\/?[^>]+(>|$)/g, "")}
                </p> */}
                <p
                  className="text-muted second"
                  dangerouslySetInnerHTML={{
                    __html: selectedNotification.message,
                  }}
                ></p>

                {/* <div className="big-img-bt">
                  <Button
                    className="popupButton"
                    onClick={() => setShowModal(false)}
                  >
                    CLOSE
                  </Button>
                </div> */}
                <div className="big-img-bt">{renderButton()}</div>
              </>
            )}
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
}

export default Notification;
